import { rootStore } from '../store/root-store';

const promiseTimeout = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const retryingFetch = async (
  url: RequestInfo,
  options?: RequestInit,
  retry = 5,
  delayMS = 200,
  attempt = 1
): Promise<Response> => {
  try {
    return await fetch(url, options);
  } catch (err) {
    if (retry <= 1) {
      throw err;
    }
    await rootStore.onlineStatusStore.waitOnline();
    await promiseTimeout(delayMS * attempt);
    return retryingFetch(url, options, retry - 1, delayMS, attempt + 1);
  }
};
